import { SelectInputItemProps } from 'types/SelectInputItemProps';

export const positions: SelectInputItemProps[] = [
	{ id: 'bottom-right', option: 'Inferior direito' },
	{ id: 'bottom-left', option: 'Inferior esquerdo' },
	{ id: 'top', option: 'Parte superior' },
	{ id: 'description', option: 'Descrição' }
];
